module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity/product-images/frat-product-6-aea3fdb10501d39329135befe917890e.jpg";